import dynamic from 'next/dynamic';
import { Fragment } from 'react';

const LoadingAnimation = dynamic(() => import('ui/components/atoms/LoadingAnimation'), {
  ssr: true,
});

interface BtnConfirmProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
  loading?: boolean;
  iconType?: 'fill' | 'outline' | 'text' | 'icon';
  size?: 'large' | 'small';
  disabled?: boolean;
  block?: boolean;
  className?: string;
  isLoading?: boolean;
  pressed?: boolean;
  type?: 'button' | 'submit';
  colorSocialMediaContainer?: string;
  variant?: string;
  rounded?: boolean;
}

const BtnConfirm = ({
  children,
  iconType = 'fill',
  pressed = false,
  disabled = false,
  block = false,
  isLoading = false,
  className = '',
  rounded = true,
  onClick = () => {},
  ...props
}: BtnConfirmProps & React.ComponentProps<'button'>) => {
  const classNameAssigned = [
    'flex justify-end items-center p-3 gap-x-3 text-base font-bold md:p-4 md:justify-center md:flex-1',
    block ? 'w-full' : '',
    pressed ? 'pressed' : '',
    disabled ? 'cursor-default !bg-reliableBlack20' : '',
    isLoading ? 'justify-center !bg-reliableBlack20 cursor-default md:px-4 md:py-1.5' : '',
    className,
    rounded ? 'md:rounded' : '',
  ];

  return (
    <button
      onClick={onClick}
      className={classNameAssigned.join(' ')}
      disabled={disabled || isLoading}
      {...props}
    >
      {children ? !isLoading ? children : <LoadingAnimation /> : <Fragment />}
    </button>
  );
};

export default BtnConfirm;
